import { clsx } from 'clsx';
import type { PropsWithChildren } from 'react';

import styles from './legacyButton.module.css';

type ButtonProps = PropsWithChildren<{
  ariaLabel: string;
  onClick?: () => void;
  selected?: boolean;
}>;

/** @todo replace with Reefer's tertiary button */
export const LegacyButton = ({
  ariaLabel,
  children,
  onClick,
  selected,
}: ButtonProps) => (
  <button
    aria-label={ariaLabel}
    className={clsx(styles['button'], selected && styles['button--selected'])}
    onClick={onClick}
  >
    {children}
  </button>
);
